/**
 * @generated SignedSource<<f4c4dca667ce5d7659ab2e4c55588fb5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleLeadingArticle$data = {
  readonly displaySlideShow: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"articleLeadingImagesContent" | "contentCoverVideoContent" | "contentSchemaRenderContent" | "helpersIsArticleVideoAsHeroArticle">;
  readonly " $fragmentType": "articleLeadingArticle";
};
export type articleLeadingArticle$key = {
  readonly " $data"?: articleLeadingArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleLeadingArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleLeadingArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displaySlideShow",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleLeadingImagesContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentCoverVideoContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentSchemaRenderContent"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "helpersIsArticleVideoAsHeroArticle",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FormattedValue",
          "kind": "LinkedField",
          "name": "multimediaEmbed",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "json",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "049246e0c0649c29d8b74f1c674b76dd";

export default node;
